import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from './components/Index'
import Cookies from './pages/misc/Cookies'
import PaymentInfo from './components/PaymentInfo'

import Contacts from './pages/contacts'
import EuroProjects from './pages/euro-projects'
import CustomerServicePolicies from './pages/misc/CustomerServicePolicies'
import Event from './components/Event'
import SeatsIo from './components/Event/SeatsIo'
import CompanyEvents from './pages/CompanyEvents'

import TermsAndConditions from './pages/misc/TermsAndConditions'
import PrivacyPolicy from './pages/misc/PrivacyPolicy'
import Gastrosilvester from './pages/Gastrosilvester'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Index, name: 'index' },
    { path: '/contacts', component: Contacts, name: 'contacts' },
    { path: '/euro-projects', component: EuroProjects, name: 'euro-projects' },
    {
      path: '/privacy-policy',
      component: PrivacyPolicy,
      name: 'privacy-policy',
    },
    {
      path: '/terms-and-conditions',
      component: TermsAndConditions,
      name: 'terms-and-conditions',
    },
    { path: '/cookies', component: Cookies, name: 'cookies' },
    {
      path: '/payment-information',
      component: PaymentInfo,
      name: 'payment-info',
    },
    {
      path: '/customer-service-policies',
      component: CustomerServicePolicies,
      name: 'customer-service-policies',
    },
    { path: '/seatsio', component: SeatsIo, name: 'seats-io' },
    { path: '/event/:id', component: Event, name: 'event-show' },
    {
      path: '/company/:name',
      component: CompanyEvents,
      name: 'company-events',
    },
    {
      path: '/fts',
      component: CompanyEvents,
      name: 'company-events-fts',
    },
    {
      path: '/raw-creative',
      component: CompanyEvents,
      name: 'company-events-raw-creative',
    },
    {
      path: '/artvent',
      component: CompanyEvents,
      name: 'company-events-artvent',
    },
    {
      path: '/moonlight',
      component: CompanyEvents,
      name: 'company-events-moonlight',
    },
    {
      path: '/dock5',
      component: CompanyEvents,
      name: 'company-events-dock5',
    },
    {
      path: '/fabric',
      component: CompanyEvents,
      name: 'company-events-fabric',
    },
    {
      path: '/modabar',
      component: CompanyEvents,
      name: 'company-events-modabar',
    },
    {
      path: '/papihans',
      component: CompanyEvents,
      name: 'company-events-papihans',
    },
    {
      path: '/gastrosilvester',
      component: Gastrosilvester,
      name: 'gastrosilvester',
    },
    {
      path: '/:any',
      component: CompanyEvents,
    },
  ],
})

export { router }
